import { render } from "./tickets-index.vue?vue&type=template&id=c7c8620c"
import script from "./tickets-index.vue?vue&type=script&lang=js"
export * from "./tickets-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__